import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Scale } from 'lucide-react';
export function UniqueMethod() {
  return <section className="py-24 bg-brand-cream relative overflow-hidden" data-id="element-151">
      {/* Decorative background */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full bg-brand-pink/10 rounded-l-full blur-3xl" data-id="element-152" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-153">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-154">
          <FadeIn direction="right" className="w-full md:w-1/3 flex justify-center" data-id="element-155">
            <div className="w-48 h-48 rounded-full bg-brand-rose flex items-center justify-center shadow-2xl shadow-brand-rose/30 border-4 border-brand-gold/30" data-id="element-156">
              <Scale className="w-24 h-24 text-brand-gold" data-id="element-157" />
            </div>
          </FadeIn>

          <div className="w-full md:w-2/3" data-id="element-158">
            <FadeIn data-id="element-159">
              <h2 className="text-3xl md:text-4xl font-bold text-brand-rose mb-6" data-id="element-160">
                El Método Anti-Agencia
              </h2>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-161">
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-162">
                He creado el Método Anti-Agencia. Este sistema utiliza la Ley
                Federal FCRA (Sección 609) a tu favor. No pedimos por favor;
                exigimos legalmente que los burós de crédito prueben que la
                deuda es real y exacta. Si no tienen el contrato original con tu
                firma (y casi nunca lo tienen), están obligados por ley a borrar
                la cuenta de tu reporte.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}